'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { DONATION_ROUTES } from '@/constants';
import { FooterMobile } from './_components/FooterMobile';
import { FooterPc } from './_components/FooterPc';
export const Footer = () => {
  const $ = _c(10);
  const pathname = usePathname();
  let T0;
  let t0;
  let t1;
  if ($[0] !== pathname) {
    let t2;
    bb0: switch (pathname) {
      case DONATION_ROUTES.GIFTS.pathname:
        {
          t2 = {
            pc: "pb-100",
            mobile: "pb-150"
          };
          break bb0;
        }
      default:
        {
          t2 = {
            pc: "",
            mobile: ""
          };
        }
    }
    const className = t2;
    t1 = <FooterPc className={cn("mobile-tablet:hidden", className.pc)} />;
    T0 = FooterMobile;
    t0 = cn("hidden mobile-tablet:block", className.mobile);
    $[0] = pathname;
    $[1] = T0;
    $[2] = t0;
    $[3] = t1;
  } else {
    T0 = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  let t2;
  if ($[4] !== T0 || $[5] !== t0) {
    t2 = <T0 className={t0} />;
    $[4] = T0;
    $[5] = t0;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};